
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import Header from './Header.vue';
    import Footer from './Footer.vue';
    import StatusDrawer from './StatusDrawer.vue';
    import GlobalProgress from '@/components/GlobalProgress.vue';
    import { Prop, Watch } from 'vue-property-decorator';
    import Photo from '../model/Photo';
    import SessionDrawer from './SessionDrawer.vue';
    import store from '@/store';
    import { getModule } from 'vuex-module-decorators';
    import ChatModule from '../store/modules/Chat';
    import SessionsModule from '../store/modules/Sessions';
    import ChatWindow from './header/ChatWindow.vue';
    import Title from './Title.vue';
    import CommandCenter from './command-center/CommandCenter.vue'
    import ReplaceDialog from './ReplaceDialog.vue';
    import FinalizePhotos from './FinalizePhotos.vue';

    const chatModule = getModule(ChatModule, store);
    const sessionsModule = getModule(SessionsModule, store);

    @Component({
        components: {
            Header,
            Footer,
            StatusDrawer,
            GlobalProgress,
            SessionDrawer,
            ChatWindow,
            Title,
            CommandCenter,
            ReplaceDialog,
            FinalizePhotos,
        },
    })
    export default class App extends Vue {
        private transferDrawerOpen: boolean = false;
        private sessionDrawerOpen: boolean = false;
        private showScrollToTop = false;

        get isInsideFolderAndSessionList() {
            return this.$route.name === 'sessionList' && sessionsModule.folderState.isInsideFolder;
        }

        @Prop({
            default: false,
            type: Boolean,
        })
        private showUploadTray!: boolean;

        @Prop({
            default: () => [],
            type: Array,
        })
        private selectedPhotos!: Photo[];

        @Prop({
            default: () => [],
            type: Array,
        })
        private additionalClasses!: string[];

        mounted() {
            window.addEventListener('scroll', (e) => {
                this.showScrollToTop = window.scrollY > 500;
            });
        }

        get currentChat() {
            return chatModule.currentChat;
        }

        @Watch('currentChat')
        focusChat() {
            Vue.nextTick(() => this.$refs.chatWindow && (this.$refs.chatWindow as ChatWindow).focus());
        }
    }
